import manifest from './angular-app-manifest.mjs';
import { ɵsetAngularAppManifest } from '@angular/ssr';
ɵsetAngularAppManifest(manifest);